import type { PublicRoute } from "../../../routes/registry";
import ContactPage from "./ContactPage";

/** BR-WEB-004 — the legacy Contact title and meta description (baseline § 3). */
const route: PublicRoute = {
  path: "/contact",
  element: <ContactPage />,
  title: "Contact Greatway Patios | (07) 4636 1766 | 396 South Street",
  description:
    "Call Greatway Patios on (07) 4636 1766 or by visiting us at 396 South Street, Toowoomba, Queensland 4350",
};

export default route;
